import * as yup from 'yup'

const AdminUserFormScheme = {
  info: yup.object().shape({
    nom: yup.string().required('errors.form.empty'),
    prenom: yup.string().required('errors.form.empty'),
    email: yup.string().required('errors.form.empty').email('errors.form.email'),
    mobile: yup.string().required('errors.form.empty'),
    fonction: yup.string(),
    societeId: yup.string().when(['typeUtilisateur'], {
      is: (typeUtilisateur: 'VIPARIS' | 'PRESTATAIRE' | 'ORGANISATEUR' | 'EXPOSANT') =>
        typeUtilisateur === 'PRESTATAIRE',
      then: yup.string().required('errors.form.empty'),
      otherwise: yup.string().max(0),
    }),
    typeUtilisateur: yup.string().oneOf(['VIPARIS', 'PRESTATAIRE', 'ORGANISATEUR', 'EXPOSANT'], 'errors.form.empty'),
    codeMagic: yup.string().when(['typeUtilisateur'], {
      is: (typeUtilisateur: 'VIPARIS' | 'PRESTATAIRE' | 'ORGANISATEUR' | 'EXPOSANT') => typeUtilisateur === 'VIPARIS',
      then: yup.string().required('errors.form.empty'),
      otherwise: yup.string(),
    }),
  }),
  scope: yup.object().shape({
    scopes: yup.array(),
  }),
  site_viparis: yup.object().shape({
    sites: yup.array(),
  }),
  site: yup.object().shape({
    sites: yup.array().min(1),
  }),
  manif: yup.object().shape({
    manifestations: yup.array().when(['typeUtilisateur'], {
      is: (typeUtilisateur: 'VIPARIS' | 'PRESTATAIRE' | 'ORGANISATEUR' | 'EXPOSANT') => typeUtilisateur === 'VIPARIS',
      then: yup.array(),
      otherwise: yup.array().min(1),
    }),
  }),
}

const AdminUserFormFields: { [key in AdminUserStep]: (keyof AdminUserForm)[] } = {
  info: ['nom', 'prenom', 'email', 'mobile', 'fonction', 'societeId', 'typeUtilisateur', 'codeMagic'],
  scope: ['scopes'],
  site: ['sites'],
  site_viparis: ['sites'],
  manif: ['manifestations'],
}

export { AdminUserFormScheme, AdminUserFormFields }
